/**
 * Customer Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines customer-related routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

// Customers feature pages
const CustomersPage = lazy(() => import('@/features/customers/ui/pages/customers-page'));
const CustomerDetailPage = lazy(() => import('@/features/customers/ui/pages/customer-detail-page'));

// New create page
const CustomerCreatePage = lazy(() => import('@/features/customers/ui/pages/add-customer-page'));

// Note: customer edit happens inline on CustomerDetailPage via `?edit=true`.
// There is no separate edit route.

export const customerRoutes: RouteGroup = {
  name: 'customers',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.CUSTOMERS,
      component: CustomersPage,
      meta: {
        title: 'customers:title',
        icon: 'UsersIcon',
        showInNav: true,
        navOrder: 5,
      },
    },
    {
      path: ROUTE_PATHS.CUSTOMER_CREATE,
      component: CustomerCreatePage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.AGENT],
      },
      meta: {
        title: 'customers:create.title',
        parent: ROUTE_PATHS.CUSTOMERS,
      },
    },
    {
      path: ROUTE_PATHS.CUSTOMER_DETAIL,
      component: CustomerDetailPage,
      meta: {
        title: 'customers:detail.title',
        parent: ROUTE_PATHS.CUSTOMERS,
      },
    },
  ],
};
